import env from "../../utils/env"

const API_BASE_URL = env("REACT_APP_API_BASE_URL")!

export const endpoints = {
    questions: `${API_BASE_URL}/questions`,
    questionsGenerateTitle: `${API_BASE_URL}/questions/generate-title`,

    subscriptions: `${API_BASE_URL}/subscriptions`,

    users: `${API_BASE_URL}/users`,
    usersMe: `${API_BASE_URL}/users/me`,

    miscellaneousContactUs: `${API_BASE_URL}/miscellaneous/contact-us`,

    admin: `${API_BASE_URL}/admin`,
    adminUsers: `${API_BASE_URL}/admin/users`,
    adminInvitations: `${API_BASE_URL}/admin/invitations`,
    adminExcludedFiles: `${API_BASE_URL}/admin/excluded-files`,

    files: `${API_BASE_URL}/files`,
    filesRefreshSourceUrl: `${API_BASE_URL}/files/refresh-source-url`,
    filesValidateSources: `${API_BASE_URL}/files/validate-sources`,
    filesValidateFileIds: `${API_BASE_URL}/files/validate-file-ids`,
    filesEvents: `${API_BASE_URL}/files/events`,

    superAdmin: `${API_BASE_URL}/super-admin`,
    superAdminCheck: `${API_BASE_URL}/super-admin/check`,
    superAdminTenants: `${API_BASE_URL}/super-admin/tenants`,
    superAdminUsers: `${API_BASE_URL}/super-admin/users`,
    superAdminFiles: `${API_BASE_URL}/super-admin/files`,
    superAdminFilesBulk: `${API_BASE_URL}/super-admin/files/bulk`,
    superAdminFilesSync: `${API_BASE_URL}/super-admin/files/sync`,
    superAdminFilesEvents: `${API_BASE_URL}/super-admin/files/events`,
    superAdminFeedback: `${API_BASE_URL}/super-admin/feedback`,

    feedback: `${API_BASE_URL}/feedback`,

    ask: `${API_BASE_URL}/ask`,
}

export const QNA_SOURCE_DOCUMENTS_SEPARATOR = "<<<QNA_SOURCE_DOCUMENTS_SEPARATOR>>>"
